require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-pages-covid-19-update.json") })
        }
      }, "path---en-pages-covid-19-update");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-pages-covid-19-update!./.cache/json/en-pages-covid-19-update.json
// module id = 750
// module chunks = 231608221292675